import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files for marketing
import commonEN from './locales/en/common.json';
import landingEN from './locales/en/landing.json';
import privacyEN from './locales/en/privacy.json';
import termsEN from './locales/en/terms.json';
import cookieConsentEN from './locales/en/cookie-consent.json';

import commonDE from './locales/de/common.json';
import landingDE from './locales/de/landing.json';
import privacyDE from './locales/de/privacy.json';
import termsDE from './locales/de/terms.json';
import cookieConsentDE from './locales/de/cookie-consent.json';

import commonIT from './locales/it/common.json';
import landingIT from './locales/it/landing.json';
import privacyIT from './locales/it/privacy.json';
import termsIT from './locales/it/terms.json';
import cookieConsentIT from './locales/it/cookie-consent.json';

import commonFR from './locales/fr/common.json';
import landingFR from './locales/fr/landing.json';
import privacyFR from './locales/fr/privacy.json';
import termsFR from './locales/fr/terms.json';
import cookieConsentFR from './locales/fr/cookie-consent.json';

type Language = 'en' | 'de' | 'it' | 'fr';

// Get stored language or detect from browser
const getInitialLanguage = (): Language => {
  // Check if running in browser (not during SSR/build)
  if (typeof window === 'undefined') {
    return 'en';
  }

  try {
    const stored = localStorage.getItem('peetrack_language');
    if (stored && ['en', 'de', 'it', 'fr'].includes(stored)) {
      return stored as Language;
    }
  } catch (e) {
    // localStorage not available
  }

  try {
    // Detect from browser
    const browserLang = navigator.language;
    const browserLangShort = browserLang.split('-')[0];

    // Check for exact match first (e.g., en-US)
    if (['en', 'de', 'it', 'fr'].includes(browserLang)) {
      return browserLang as Language;
    }

    // Check for short code match
    if (['en', 'de', 'it', 'fr', 'es', 'zh', 'ja'].includes(browserLangShort)) {
      return browserLangShort as Language;
    }
  } catch (e) {
    // navigator not available
  }

  return 'en'; // Fallback to English
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEN,
        landing: landingEN,
        privacy: privacyEN,
        terms: termsEN,
        'cookie-consent': cookieConsentEN,
      },
      de: {
        common: commonDE,
        landing: landingDE,
        privacy: privacyDE,
        terms: termsDE,
        'cookie-consent': cookieConsentDE,
      },
      it: {
        common: commonIT,
        landing: landingIT,
        privacy: privacyIT,
        terms: termsIT,
        'cookie-consent': cookieConsentIT,
      },
      fr: {
        common: commonFR,
        landing: landingFR,
        privacy: privacyFR,
        terms: termsFR,
        'cookie-consent': cookieConsentFR,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'landing', 'privacy', 'terms', 'cookie-consent'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
